<template>
  <div class="virtual-tray-search col-12">
    <div class="input-group border border-light mb-3">

      <input v-model="searchtext" @input="updateSearchQuery" @keydown.enter="submitSearch" type="search"
        class="form-control border-0" :placeholder="$resourceString['account.MyProject.SearchField.Placeholder']" />
      <div class="input-group-prepend">
        <button tabindex="-1" type="submit" class="btn px-1" @click="submitSearch">
          <span class="png-icon png-icon-icons-glyph--k-search"></span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["siteProjectName"],
  data() {
    return {
      searchtext: "",
      timeout: null,

    };
  },
  computed: {
    ...mapGetters({
      selectedTab: "myTray/getselectedTabName",
    })
  },
  created(){
    this.setSiteProjectName('ProjectFeature');
  },
  watch: {
    selectedTab: {
      handler: function () {
        this.searchtext = ""
      }
    }
  },
  methods: {
    ...mapActions({
      updateSearchInput: "myTray/updateSearchInput",
      setSiteProjectName: "myTray/setSiteProjectName",
    }),
    updateSearchQuery(e) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.updateSearchInput(e.target.value);
      }, 1000);
    },

    submitSearch() {
      this.updateSearchInput(this.searchtext);
    }
  }
};
</script>
